import COMMON from "common";

const validateFileSize = (files, maxSize = COMMON.MAX_FILE_SIZES.MB_5) => {
	if (files?.length) {
		const uploadedFiles = files;

		const valid = uploadedFiles.every((o) => (!o.size ? true : o.size <= maxSize));
		return valid;
	} else if (files?.size) {
		return files?.size <= maxSize;
	} else {
		return true;
	}
};

export default validateFileSize;
